import React from 'react';
import { FiTool, FiClock } from 'react-icons/fi';
import { fmtParede } from '../utils/tempoCv';

interface MaintenanceProps {
  titulo?: string;
  mensagem?: string;
  dataFimPrevista?: string;
}

const Maintenance: React.FC<MaintenanceProps> = ({
  titulo = 'Em Manutencao',
  mensagem = 'Estamos a realizar melhorias na plataforma. Voltamos em breve.',
  dataFimPrevista,
}) => {
  // dataFimPrevista é hora de parede de CV marcada com Z: mostrar tal e qual.
  const formatDate = (d: string) => {
    try {
      return fmtParede(d, {
        day: '2-digit', month: 'long', year: 'numeric',
        hour: '2-digit', minute: '2-digit',
      }) || d;
    } catch { return d; }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-pagali-primary/5 via-white to-pagali-primary/10 flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-pagali-primary/10 flex items-center justify-center">
          <FiTool className="text-4xl text-pagali-primary" />
        </div>

        <h1 className="text-2xl font-bold text-pagali-gray-800 mb-3">{titulo}</h1>
        <p className="text-pagali-gray-600 mb-6 leading-relaxed">{mensagem}</p>

        {dataFimPrevista && (
          <div className="inline-flex items-center gap-2 bg-pagali-primary/5 text-pagali-primary px-4 py-2 rounded-xl text-sm font-medium">
            <FiClock />
            <span>Previsao de retorno: {formatDate(dataFimPrevista)}</span>
          </div>
        )}

        <div className="mt-8">
          <img src="/logo192.png" alt="Pagali" className="w-12 h-12 mx-auto opacity-30" />
        </div>
      </div>
    </div>
  );
};

export default Maintenance;
